import React from "react";

/** Compact monospace subtitle for modal headers showing IDs */
export function ModalSubtitle({ text }: { text: string }) {
  return (
    <div style={{ marginTop: 4, fontSize: "12px", fontFamily: "monospace", opacity: 0.7, overflow: "auto" }}>
      {text}
    </div>
  );
}
